import { useToast } from "@/components/feature/ToastProvider";
import type { Movie } from "@/types/movie";

interface PlayerDemoProps {
  movie: Movie;
}

export default function PlayerDemo({ movie }: PlayerDemoProps) {
  const { showToast } = useToast();

  const handlePlay = () => {
    showToast("当前为演示状态，播放功能待接入");
  };

  return (
    <section className="mt-10 md:mt-14">
      <div className="mb-4 flex items-center gap-3">
        <span className="h-6 w-1.5 rounded-full bg-accent-500"></span>
        <h2 className="font-heading text-xl font-bold text-foreground-950">播放演示</h2>
      </div>

      <div className="relative w-full overflow-hidden rounded-lg border border-background-200/60" style={{ aspectRatio: "16 / 9" }}>
        <img
          src={movie.poster}
          alt={`${movie.title} 播放画面预览`}
          title={`${movie.title} 在线观看 - 鸭王在线观看`}
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-background-950/70"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 px-4 text-center">
          <button
            type="button"
            onClick={handlePlay}
            className="flex h-16 w-16 cursor-pointer items-center justify-center rounded-full bg-accent-500 text-background-950 transition-transform hover:scale-105 md:h-20 md:w-20"
            aria-label="播放演示"
          >
            <i className="ri-play-fill text-4xl"></i>
          </button>
          <p className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
            {movie.title}
          </p>
          <p className="max-w-lg text-xs text-foreground-700 md:text-sm">
            本站为内容演示站点，播放器仅为前端演示入口，暂未接入真实播放服务。
          </p>
        </div>

        <div className="absolute bottom-0 left-0 right-0 flex items-center gap-4 bg-background-950/80 px-4 py-3">
          <button
            type="button"
            onClick={handlePlay}
            className="flex cursor-pointer items-center gap-1 text-sm text-foreground-800"
          >
            <i className="ri-play-circle-line text-xl text-accent-500"></i>
            播放
          </button>
          <div className="h-4 w-px bg-foreground-700/40"></div>
          <div className="hidden h-1 flex-1 overflow-hidden rounded-full bg-foreground-700/30 sm:block">
            <div className="h-full w-1/3 rounded-full bg-accent-500"></div>
          </div>
          <span className="ml-auto text-xs text-foreground-600">00:00 / --:--</span>
        </div>
      </div>
    </section>
  );
}